import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as moment from 'moment';
import { InputFieldsWrapper } from '.././PTPlusStyled'
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import { Field } from 'formik'
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import Select from 'web/components/form-elements/Select';
import { adminRegisterUserApi } from 'redux/actions/adminPtPlus/index';
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";

import AlertModal from 'web/components/AlertModal';

function FeeStructure(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true)
    const [saveDisableState, setSaveDisableState] = useState(true)
    let feeTypeList = [{ value: "PERCENTAGE", label: 'Percentage' },
    { value: "COSTPERPALLET", label: 'Cost Per Pallet' }]

    let commissionTypeList = [{ value: "COMMISSIONPERCENTAGE", label: 'Percentage' },
    { value: "FLATRATE", label: 'Flat Rate' }]

    let currencyList = [{ value: "USD", label: 'USD' }]

    let personnelType = [{ value: "SALES", label: 'Sales' },
    { value: "ACCOUNT_MANAGER", label: 'Account Manager' }]

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        
         if ( fieldValues.percentageValue !== '' || fieldValues.costPerPalletValue !== '') {
            setSaveDisableState(false)
        } else setSaveDisableState(true)

        let locationTypeListTemp = [{ value: fieldValues.selectLocation, label: fieldValues.selectLocation }]
    }, [pageProps.formikProps])

    const [tooltip, setTooltip] = useState(false);
    const [tooltipSection, setTooltipSection] = useState('');
    const iIcon = (infoSection, infoTxt) => {
        return <>
            <img
                id={infoSection}
                src={information}
                style={{ position: "relative", top: '11px', left: '7px', height: '20px', width: '20px' }}
                alt="info"
            />
            <Tooltip
                placement="right"
                isOpen={tooltip && tooltipSection === infoSection}
                target={infoSection}
                toggle={() => {
                    setTooltip(!tooltip)
                    setTooltipSection(tooltipSection === '' ? infoSection : '')
                }
                }
            >
                {infoTxt}
            </Tooltip>
        </>
    }

    const adminRegisterUserFunc = async () => {
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let accountManagementValues = null
        if(fieldValues.personnelTypeContactName !== '' || fieldValues.personnelTypeEmail !== ''){
            accountManagementValues = {
                personnelType: fieldValues.personnelType,
                contactName: fieldValues.personnelTypeContactName,
                email: fieldValues.personnelTypeEmail
            }
        }
        let data = {
            id: pageProps.tempRegId,
            emailAddress: fieldValues.email?.trim(),
            otherContactEmail: fieldValues?.otherToEmail ? fieldValues?.otherToEmail.trim() : null,
            billToEmailAddress: fieldValues.billToCheckBox ? fieldValues.email?.trim() : fieldValues.billToEmail?.trim(),
            contactNumber: fieldValues.phoneNumber?.trim(),
            customerName: fieldValues.userName?.trim(),
            locationName: fieldValues.businessName?.trim(),
            notes: fieldValues.notes?.trim(),
            locationAddress: {
                name: fieldValues.businessName?.trim(),
                contactNumber: fieldValues.phoneNumber?.trim(),
                locationName: fieldValues.businessName?.trim(),
                street: fieldValues.address?.trim(),
                city: fieldValues.city?.trim(),
                state: fieldValues.state?.trim(),
                zipCode: fieldValues.zip?.trim(),
            },
            billingAddress: {
                name: fieldValues.billToCheckBox ? fieldValues.userName?.trim() : fieldValues.billToUserName?.trim(),
                contactNumber: fieldValues.billToCheckBox ? fieldValues.phoneNumber?.trim() : fieldValues.billToPhoneNumber?.trim(),
                locationName: fieldValues.billToCheckBox ? fieldValues.businessName?.trim() : fieldValues.billToBusinessName?.trim(),
                street: fieldValues.billToCheckBox ? fieldValues.address?.trim() : fieldValues.billToAddress?.trim(),
                city: fieldValues.billToCheckBox ? fieldValues.city?.trim() : fieldValues.billToCity?.trim(),
                state: fieldValues.billToCheckBox ? fieldValues.state?.trim() : fieldValues.billToState?.trim(),
                zipCode: fieldValues.billToCheckBox ? fieldValues.zip?.trim() : fieldValues.billToZip?.trim()
            },
            businessInfo: {
                taxId: fieldValues.taxID?.trim(),
                businessUrl: fieldValues.businessURL?.trim(),
                businessDescription: fieldValues.businessDescription?.trim()
            },
            feeStructure: {
                feeType: fieldValues.feeTypeRadio,
                accountManagement: accountManagementValues,
                commissionType: {
                    commission: fieldValues.commissionTypeRadio === 'COMMISSIONPERCENTAGE' ? 'PERCENTAGE' : 'FLATRATE',
                    value: fieldValues.commissionTypeRadio === 'COMMISSIONPERCENTAGE' ? fieldValues.commissionPercentageValue : fieldValues.commissionFlatRateValue,
                },
            },
            registrationStatus: "DRAFT"
        }
        if (fieldValues.feeTypeRadio === 'PERCENTAGE') {
            data.feeTypePercentage = {
                fee: fieldValues.percentageValue,
                currency: "USD"
            }
            data.feeTypeCostPallet = null
        } else {
            data.feeTypePercentage = null
            data.feeTypeCostPallet = {
                fee: fieldValues.costPerPalletValue,
                currency: "USD"
            }
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminRegisterUserApi(data, token))
        if (response.success) {
            setAlertModalContent('Details saved successfully.')
            setAlertModal(!alertModal)
            setTimeout(() => {
                pageProps.nextStepCallBack('forward', 'step3')
                setAlertModal(false)
            }, 1000)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }

    return (
        <>
            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <div style={{ display: 'flex' }}>
                        <p>Management Fee<span className='star'>&#42;</span></p>
                        {iIcon('FeeType', 'Set the management fee by choosing a percentage or cost per pallet.')}
                    </div>
                </div>

                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <div className="row">
                            {feeTypeList.map((value, index) => (
                                <div className="col-md-12">
                                    <div key={index}>
                                        <Field
                                            component={RadioButton}
                                            name="feeTypeRadio"
                                            id={value.value}
                                            defaultValue={feeTypeList[0].value}
                                            onSelect={(e) => {
                                                if (e.target.value === "PERCENTAGE") {
                                                }
                                            }}
                                            label={value.label}
                                        />
                                    </div>
                                    <div className="row flatType" >
                                        <div className="col-md-6 bordered-input">
                                            <NumberInput
                                                disabled={pageProps.formikProps.values.feeTypeRadio === 'PERCENTAGE' ?
                                                    (value.value === 'PERCENTAGE' ? false : true) :
                                                    pageProps.formikProps.values.feeTypeRadio === 'COSTPERPALLET' &&
                                                    (value.value === 'COSTPERPALLET' ? false : true)
                                                }
                                                name={value.value === 'PERCENTAGE' ? 'percentageValue' : 'costPerPalletValue'} decimalScale={3} placeholder={value.value === 'PERCENTAGE' ?'0.000%':'$0.000'} />
                                        </div>
                                        <div className="col-md-6">
                                            <Select
                                                name={value.value === 'PERCENTAGE' ? 'percentageCurrencyLists' : 'costPerPalletCurrencyLists'}
                                                data={currencyList}
                                                disabled
                                                onChangeHandler={() => {
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </InputFieldsWrapper>
                </div>
            </div>

            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <div style={{ display: 'flex' }}>
                        <p>Account Management</p>
                    </div>
                </div>

                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <div className="row">
                            <div className="col-md-6">
                                <Select
                                    name='personnelType'
                                    data={personnelType}
                                    placeholder='Personnel Type'
                                    onChangeHandler={() => {
                                    }}
                                />
                            </div>
                        </div>
                        {pageProps.formikProps.values.personnelType !== '' &&
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <TextInput name='personnelTypeContactName' placeholder={`Contact Name`} inputType='text' />
                                </div>
                                <div className={!isValidEmail ? 'col-md-6 error-styling-input' : 'col-md-6'}>
                                    <TextInput name="personnelTypeEmail" placeholder={`Email`} />
                                </div>
                            </div>
                        }
                    </InputFieldsWrapper>
                </div>
            </div>

            <div>
                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <h6 style={{ fontWeight: 'bold', fontSize: '16px', color: '#000', margin: '15px 0px 15px 0px' }}>Commission Type</h6>
                        <div className="row">
                            {commissionTypeList.map((value, index) => (
                                <div className="col-md-6">
                                    <div key={index}>
                                        <Field
                                            component={RadioButton}
                                            name="commissionTypeRadio"
                                            id={value.value}
                                            defaultValue={commissionTypeList[0].value}
                                            onSelect={(e) => {
                                                if (e.target.value === "PERCENTAGE") {
                                                }
                                            }}
                                            label={value.label}
                                        />
                                    </div>
                                    <div className="row flatType">
                                        <div className="col-md-12 bordered-input">
                                            <NumberInput
                                                disabled={pageProps.formikProps.values.commissionTypeRadio === 'COMMISSIONPERCENTAGE' ?
                                                    (value.value === 'COMMISSIONPERCENTAGE' ? false : true) :
                                                    pageProps.formikProps.values.commissionTypeRadio === 'FLATRATE' &&
                                                    (value.value === 'FLATRATE' ? false : true)
                                                }
                                                name={value.value === 'COMMISSIONPERCENTAGE' ? 'commissionPercentageValue' : 'commissionFlatRateValue'}
                                                placeholder={value.value === 'COMMISSIONPERCENTAGE' ? '0.000%' : '$0.000'}
                                                decimalScale={3} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div>
                            <p style={{ fontSize: '13px', color: '#000', marginBottom: '20px' }}>Flat Fee will be managed once the registration process is completed.</p>
                        </div>
                    </InputFieldsWrapper>
                </div>
            </div>

            <div className='button-section'>
                <div style={{ marginLeft: '80px' }}>
                    <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => adminRegisterUserFunc()}>Save</button>
                    <button className='skip-button' onClick={() => pageProps.skipButtonCall()}>Skip</button>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className='round-wrapper left' onClick={() => pageProps.nextStepCallBack('backward', 'step3')}><p></p></div>
                    <div className={saveDisableState ? 'round-wrapper right disabled' : 'round-wrapper right'} onClick={() => !saveDisableState && adminRegisterUserFunc()}><p></p></div>
                </div>
            </div>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )

}

export default FeeStructure